import { defineStore } from "pinia";
import { rootGetters } from "@/main";

const endpoints = {
    getCategoryCosts: { method: "get", url: "/catalog_data/category_costs" },
    updateCategoryCosts: { method: "put", url: "/catalog_data/category_costs" },
};

export const useCategoryCostsStore = defineStore("category_costs", {
    state: () => ({
        categoryCosts: [] as CategoryCost[],
    }),
    actions: {
        async getCategoryCosts() {
            const response = await rootGetters.api.proceedRequest(
                endpoints.getCategoryCosts
            );
            if (response) {
                this.categoryCosts = response.data;

                const levels = ["c1", "c2", "c3", "c4"];
                levels.forEach((level) => {
                    if (!this.categoryCosts.find((item) => item.level === level)) {
                        this.categoryCosts.push({ level, cost: 0 });
                    }
                });

                this.categoryCosts.sort((a, b) => a.level.localeCompare(b.level));
            }
        },
        async updateCategoryCosts(costs: CategoryCost[]) {
            await rootGetters.api
                .proceedRequest(
                    endpoints.updateCategoryCosts,
                    {},
                    {},
                    { costs }
                )
                .then((response) => {
                    if (response) {
                        this.categoryCosts = response.data;

                        const levels = ["c1", "c2", "c3", "c4"];
                        levels.forEach((level) => {
                            if (!this.categoryCosts.find((item) => item.level === level)) {
                                this.categoryCosts.push({ level, cost: 0 });
                            }
                        });
                        this.categoryCosts.sort((a, b) => a.level.localeCompare(b.level));

                        rootGetters.toast.show(
                            "info",
                            "Обновление",
                            "Коэффициенты категорий успешно обновлены."
                        );
                    }
                })
                .catch((err) => {
                    return Promise.reject(err);
                });
        },
    },
});

export interface CategoryCost {
    level: string;
    cost: number;
}

